// Para respeitar os espaçamentos internos do texto utilize a função acompanhado do estilo 
// 'whiteSpace: pre-wrap' no componente Typography. :)

export const formatTextToLines = (text) => {
    if (!text) return [];

    return text
        .replace(/\r\n/g, '\n')
        .split('\n');
};